var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vue-good-table',{ref:"attachTable",attrs:{"styleClass":"vgt-table bordered table-dropdown striped","mode":"remote","columns":_vm.columns,"rows":_vm.rows}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }